import { render, staticRenderFns } from "./InsuranceStatusListing.vue?vue&type=template&id=316df762"
import script from "./InsuranceStatusListing.vue?vue&type=script&lang=js"
export * from "./InsuranceStatusListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports